import { LegalBasis } from '@dreryk/egabinet-patient-frontend-api';

import { commonTranslationKeys, FieldControllerProps, useTranslate } from '@dreryk/react-common';
import { ClassNameProp, Select } from '@dreryk/react-components';

import { entitlementStatementsTranslationKeys } from '../../translations';

const TriggerLabelExtractor = (statementLegalBasis?: LegalBasis): string => {
   const translate = useTranslate();
   return statementLegalBasis
      ? translate(entitlementStatementsTranslationKeys.legalBasis[statementLegalBasis.value])
      : '';
};

type LegalBasisFieldProps = FieldControllerProps<'legalBasis', LegalBasis | null> &
   ClassNameProp & {
      readonly legalBasis: LegalBasis[];
   };

export const LegalBasisField = (props: LegalBasisFieldProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: true,
   });

   return (
      <Select<LegalBasis>
         className={props.className}
         triggerLabelExtractor={TriggerLabelExtractor}
         testId={props.name}
         label={entitlementStatementsTranslationKeys.createModal.legalBasis}
         placeholder={commonTranslationKeys.choose}
         controller={controller}
      >
         <Select.List<LegalBasis> items={props.legalBasis} keyExtractor={'value'}>
            {(basis: LegalBasis) => (
               <Select.Item
                  item={basis}
                  testId={basis.value}
                  key={basis.value}
                  label={entitlementStatementsTranslationKeys.legalBasis[basis.value]}
               />
            )}
         </Select.List>
      </Select>
   );
};
